<template>
	<div class="acc__item" :class="[open ? 'open' : '']">
		<div class="acc__item-head" @click="open = !open">
			<slot name="head"></slot>
		</div>
		<Collapse :open="open">
			<div class="acc__item-body">
				<div class="acc__item-content">
					<slot name="body"></slot>
				</div>
			</div>
		</Collapse>
	</div>
</template>

<script>

import Collapse from "./Collapse.vue";

export default {
	components: {
		Collapse
	},

	props: {
		openState: {
			type: Boolean,
			default: false
		},

		id: {
			type: [String, Number]
		}
	},

	data() {
		return {
			open: false
		}
	},

	watch: {
		openState(state) {
			this.open = state;
		},

		open(state) {
			window.location.hash = state && this.id ? this.id : '';
		}
	},

	mounted() {
		this.open = this.openState;
		if (this.id && window.location.hash.replace('#', '') === this.id) {
			this.open = true;
			this.scrollToSelf();
		}
	},

	methods: {
		scrollToSelf() {
			setTimeout(() => {
				window.scrollTo({
					top: this.$el.getBoundingClientRect().top + window.pageYOffset - window.innerHeight / 4,
					behavior: 'smooth'
				});
			}, 777)
		}
	}
}
</script>